import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosAuth } from "./axios";

const useGetAdmins = (searchTerm = '') => {
  const fetchData = async () => {
    try {
      const response = await axiosAuth.get(`/admins${searchTerm ? `?search=${searchTerm}` : '' }`);
  
     // const response = await axiosAuth.get(`/admins${searchTerm ? `?search=${searchTerm}` : '' }`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch data");
    }
  };

  // Use the useQuery hook to handle caching, loading, and error states
  return useQuery(["adminData"], fetchData);
};

const useGetAllUsers= (searchTerm = '') => {
    const fetchData = async () => {
      try {
        const response = await axiosAuth.get(`/users${searchTerm ? `?search=${searchTerm}` : '' }`);
        return response.data;

      } catch (error) {
        throw new Error("Failed to fetch data");
      }
    };
  
    // Use the useQuery hook to handle caching, loading, and error states
    return useQuery(["UsersData"], fetchData);
  };

const useRegisterUser = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await axiosAuth.post("/users", data);
      console.log(response, 'response from register hook')
      return response;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(["adminData"]);
        await queryClient.invalidateQueries(["UsersData"]);
        await queryClient.invalidateQueries(["orgUserData"]);
      },
    }
  );
};

const useGetOrgUsers= (searchTerm) => {
    //console.log(org)
    const fetchData = async () => {
      try {
        // Use the Axios instance to make the GET request
        const response = await axiosAuth.get(`/users${searchTerm ? `?search=${searchTerm}` : '' }`);
        return response.data;
      } catch (error) {
        throw new Error("Failed to fetch data");
      }
    };
  
    // Use the useQuery hook to handle caching, loading, and error states
    return useQuery(["orgUserData"], fetchData);
  };

  const useUserLoginData= () => {
    
    const fetchData = async () => {
      try {
        // Use the Axios instance to make the GET request
        const response = await axiosAuth.get(`/auth/me`);
        return response.data;
      } catch (error) {
        throw new Error("Failed to fetch data");
      }
    };
  
    // Use the useQuery hook to handle caching, loading, and error states
    return useQuery(["loggedUserData"], fetchData);
  };

  const useGetPatients= (searchTerm = '') => {
  
    const fetchData = async () => {
      try {
        // Use the Axios instance to make the GET request
        const response = await axiosAuth.get(`/patients${searchTerm ? `?search=${searchTerm}` : '' }`);
        return response.data;
      } catch (error) {
        throw new Error("Failed to fetch data");
      }
    };
  
    return useQuery(["orgUserData"], fetchData);
  };

  const useGetAllPatients= () => {
      const fetchData = async () => {
        try {
          // Use the Axios instance to make the GET request
          const response = await axiosAuth.get("/patient");
         
          return response.data;
  
        } catch (error) {
          throw new Error("Failed to fetch data");
        }
      };

      return useQuery(["patientsData"], fetchData);
    };

    const useDeleteUsersDoctor = () => {
      const queryClient = useQueryClient();
    
      const deleteUser = async (id) => {
        try {
          const response = await axiosAuth.delete(`/users/${id}`);
    
          return response.data;
        } catch (error) {
          throw new Error("Failed to delete user");
        }
      };
    
      return useMutation(deleteUser, {
        onSuccess: () => {
          queryClient.invalidateQueries('orgUserData');
        },
      });
    };
    

    const useDeactivateUsersDoctor = () => {
      const queryClient = useQueryClient();
    
      const deactivateUser = async ({ id, isActive }) => {
        try {
          const response = await axiosAuth.patch(`/users/${id}`, { isActive });
    
          return response.data;
        } catch (error) {
          throw new Error("Failed to deactivate user");
        }
      };
    
      return useMutation(deactivateUser, {
        onSuccess: () => {
          queryClient.invalidateQueries('orgUserData');
        },
      });
    };

    const useCreatePatient = () => {
      const queryClient = useQueryClient();
    
      return useMutation(
        async (data) => {
          const response = await axiosAuth.post("/patients", data);
          return response.data;
        },
        {
          onSuccess: async () => {
            await queryClient.invalidateQueries(["adminData"]);
          },
        }
      );
    };

    const useEditPatientData = ()=> {
      const queryClient = useQueryClient();
      const editPatient = async ({ id, dataToEdit }) => {
        try {
          const response = await axiosAuth.patch(`/patients/${id}`, dataToEdit);
    
          return response.data;
        } catch (error) {
          throw new Error("Failed to deactivate user");
        }
      };
    
      return useMutation(editPatient, {
        onSuccess: () => {
          queryClient.invalidateQueries(['orgUserData']);
        },
      });
    }
    
    const useDeletePatient = () => {
      const queryClient = useQueryClient();
    
      const deletePatient = async ({id}) => {
        try {
          const response = await axiosAuth.delete(`/patients/${id}`);
    
          return response.data;
        } catch (error) {
          throw new Error("Failed to delete user");
        }
      };
    
      return useMutation(deletePatient, {
        onSuccess: () => {
          queryClient.invalidateQueries('orgUserData');
        },
      });
    };

export { 
  useGetAdmins,
   useRegisterUser,
   useGetAllUsers,
   useGetOrgUsers,
   useGetAllPatients,
   useDeleteUsersDoctor,
   useDeactivateUsersDoctor,
   useGetPatients,
   useCreatePatient,
   useUserLoginData,
   useEditPatientData,
   useDeletePatient,
 };
